import { useCallback, useState } from 'react';

export const useLocalHooks = () => {
  const [isShowVipOnlyModal, setIsShowVipOnlyModal] = useState(false);

  const onClickHandler = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setIsShowVipOnlyModal(true);
    },
    []
  );

  const closeVipOnlyModal = useCallback(() => {
    setIsShowVipOnlyModal(false);
  }, []);

  return {
    onClickHandler,
    isShowVipOnlyModal,
    closeVipOnlyModal,
  };
};
